import React, { DispatchWithoutAction, FC } from 'react';

import { SvgWrapper } from 'components/atoms/svg-wrapper';
import { checkboxChecked, checkboxUnchecked } from 'assets/icons';

import styles from './styles.module.css';

interface IRowSelectionCheckboxProps {
  isHeader?: boolean;
  isChecked: boolean;
  onClick: DispatchWithoutAction;
}

export const RowSelectionCheckbox: FC<IRowSelectionCheckboxProps> = ({ isHeader, isChecked, onClick }) => {
  return (
    <div className={styles.wrapper}>
      <span className={styles.checkboxIcon} onClick={onClick}>
        {isChecked ? (
          <SvgWrapper width={18} height={18} details={checkboxChecked} color={isHeader ? '#707070' : '#ffffff'} />
        ) : (
          <SvgWrapper width={15} height={15} details={checkboxUnchecked} />
        )}
      </span>
    </div>
  );
};
